export const TYPEFIXED = {
    registration: 'registrationFee',
    exam: 'examRegistrationFee',
    pro: 'zinkerzPro',
    nothing: 'nothing'
}

export default {TYPEFIXED}